export default __webpack_public_path__ + "static/media/img_introduce_benefit_2.84068bdc.png";